import React from "react";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Login from "../view/login";
import Dashboard from "../view/home/Dashboard";
import Members from "../view/members";
import Summary from "../view/summary";
import Invoice from "../view/invoices";
import Request from "../view/Request";
import MemReq from "../view/memreq";
import Timesheet from "../view/timesheet";
import Summaryreq from "./../view/summaryreq/index";
import PublicRoutes from "./PublicRoutes";
import ProtectedRoutes from "./ProtectedRoutes";
import { useSelector } from "react-redux";
import ScreenShots from "../view/screenshots";
import { Chart } from "../view/home/Chart";
import Rembursment from "../view/reimbursement";
import AdminRembursment from "../view/allreimbursement";
import AdminRembursmentList from "../view/allreimbursement/AdminRembursmentList";
import Dashreport from "../components/SharedComponets/Dashreport";

//Routing
const AppRoutes = () => {
  const userProfile = useSelector((state) => state.user.userinfo);

  return (
    <>
      <BrowserRouter>
        <Routes>

          <Route path="login" element={<PublicRoutes />}>
            <Route path="/login" element={<Login />} />
          </Route>

          <Route path="/" exact element={<ProtectedRoutes />}>
            <Route path="/" element={<Dashboard />} />
            {userProfile?.MemberRole == 2 &&
              <Route path="/members" element={<Members />} />}
            {userProfile?.MemberRole == 2 &&
              <Route path="/allsummary" element={<Summary />} />}
            <Route path="/invoice" element={<Invoice />} />
            

              <Route path="/medical" element={< Rembursment />} />
            {userProfile?.MemberRole == 2 &&

              <Route path="/adminRembursmentList" element={<AdminRembursmentList />} />}
            {userProfile?.MemberRole == 2 &&

              <Route path="/adminRembursment" element={<AdminRembursment />} />}

            <Route path="/timesheet" element={<Timesheet />} />
            <Route path="/deshreport" element={<Dashreport />} />
            <Route path="/chart" element={<Chart />} />

            {userProfile?.MemberRole == 2 &&
              <Route path="/allrequests" element={< Request />} />}
            <Route path="/requests" element={<MemReq />} />
            {userProfile?.MemberRole == 2 &&
              <Route path="/monitor" element={<ScreenShots />} />}
            <Route path="/summary" element={<Summaryreq />} />
          </Route>

          <Route path="*" element={<Navigate replace to="/" />} />
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default AppRoutes;
